import { render, staticRenderFns } from "./adminAccountList.vue?vue&type=template&id=b64aaf1a&scoped=true"
import script from "./adminAccountList.vue?vue&type=script&lang=js"
export * from "./adminAccountList.vue?vue&type=script&lang=js"
import style0 from "./adminAccountList.vue?vue&type=style&index=0&id=b64aaf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64aaf1a",
  null
  
)

export default component.exports